<template>
  <div>
    <loader class="imageLoader" :loading="loading" />
    <div class="tab__Item" v-if="items">
      <error-prompt class="error--Modal" :errors="errors"></error-prompt>
      <table class="postsTable">
        <thead>
          <tr>
            <th>User</th>
          </tr>
        </thead>
        <tbody>
          <user :showAdmin="false" v-for="item in items" :key="item.id" :item="item" :changeProp="changeProp"></user>
        </tbody>
      </table>

      <div class="error" v-if="items && items.length === 0">
        <p>No users are currently pending to join.</p>
      </div>
    </div>
    <success-prompt :updated="updated" :message="prompt.success"></success-prompt>

    <transition name="fade">
      <router-view v-if="loading === false"></router-view>
    </transition>
  </div>
</template>

<script>
import HTTP from '@/http-common.js'

import User from '@/components/listing/User.vue'
import Loader from '@/components/partials/Loader.vue'

import SuccessPrompt from '@/components/editor/SuccessPrompt.vue'
import ErrorPrompt from '@/components/editor/ErrorPrompt.vue'

export default {
  name: 'Pending',
  props: ['orgID', 'search'],
  components: {
    User,
    Loader,
    SuccessPrompt,
    ErrorPrompt,
  },
  data() {
    return {
      loading: true,
      prompt: {
        success: '',
      },
      updated: false,
      errors: [],
    }
  },
  computed: {
    org() {
      return this.$store.state.accounts.org
    },
    items() {
      if (this.search.length > 0)
        return this.$store.state.accounts.users.pending.filter((user) =>
          user.name.toLowerCase().includes(this.search.toLowerCase())
        )
      return this.$store.state.accounts.users.pending
    },
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    changeProp(id, obj, message) {
      let orgID = this.org.id
      if (this.orgID) orgID = this.orgID

      HTTP.post(`org/${orgID}/member/update/${id}`, obj)
        .then(() => {
          this.updated = true
          this.loading = false
          this.prompt.success = message

          // Enable edit
          setTimeout(() => {
            this.updated = false
          }, 3000)

          this.getUsers()
        })
        .catch((e) => {
          console.log(e)
          this.errors.push(e.response.data)
          this.loading = false
        })
    },
    getUsers() {
      let orgID = this.org.id
      if (this.orgID) orgID = this.orgID

      this.$store.dispatch('getUsers', { status: 'pending', orgID }).then(
        () => {
          this.loading = false
        },
        (error) => {
          console.error(error)
        }
      )
    },
  },
}
</script>
